const unitOfMeasurements = Object.freeze({
  UOM: "UoM",
  UNITS: "Units",
  COST: "Cost",
  PRICE: "Price",
});

export default unitOfMeasurements;
